const config = {
    api_backend: process.env.REACT_APP_API,
    api_dialog: process.env.REACT_APP_DIALOG_API,
    dialog_token: process.env.REACT_APP_DIALOG_TOKEN,
    img_url: process.env.REACT_APP_IMG,
    editor_url: process.env.REACT_APP_EDITOR_URL,
    api_texttran: process.env.REACT_APP_TEXT_TRAN
  };
  export default config;
  